// 一个指标多条数据的处理方式
export function handleOneIndictorToMoreLine (resData = []) {
  const delHeader = resData.splice(0, 1)
  const labelList = [...new Set(resData.map(item => { return item.label }))]
  const xAxis = [...new Set(resData.map(item => { return item.x }))]
  const chartData = xAxis.map((item, index) => {
    const haha = { x: item }
    labelList.forEach((label, labelIndex) => {
      const list = resData.filter(data => {
        return data.label === label
      }).find(bar => {
        return bar.x === item && bar.label === label
      })

      haha[`y_${labelIndex}`] = list?.y || 0
    })
    return haha
  })
  const header = { x: delHeader[0].x }
  labelList.forEach((label, index) => {
    header[`y_${index}`] = label
  })
  chartData.unshift(header)

  return chartData
}
